import { Component, Input } from '@angular/core';

/**
 * Public-surface footer. Rendered on `/intake` (the anonymous "report a login
 * problem" door) and on `/login` — NOT in the authenticated agent shell, which
 * has no marketing footer.
 *
 * `showTagline` gates the brand tagline only. `.claude/knowledge/branding.md`
 * mandates it for "public / marketing-adjacent surfaces", which `/intake` is —
 * a sign-in page is not, so `/login` opts out while keeping the legal line.
 * Default `true` so the branding-mandated case needs no opt-in.
 *
 * The tagline text mirrors bluetitan.com's footer line, verified against the live
 * site 2026-08-26. The previous wording here ("Turn video overload into clarity")
 * was superseded. NOTE: `.claude/knowledge/branding.md` in the WORKSPACE repo still
 * records the old phrase — it needs the same update, in its own PR.
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <footer class="bt-footer" data-testid="public-footer">
      <p>&copy; {{ year }} BlueTitan LLC. All rights reserved.</p>
      @if (showTagline) {
        <p data-testid="footer-tagline">Turn historical video overload into immediate value</p>
      }
    </footer>
  `,
})
export class FooterComponent {
  /** Set false to suppress the brand tagline (see class docstring). */
  @Input() showTagline = true;

  year = new Date().getFullYear();
}
